<template>
  <div id="app" v-bind:class="{ black_bg: view.black, white_bg: !view.black }">
    <Helper 
      v-if="search.showHelper" 
      @click="showHelper" />

    <Frontpage 
      v-if="view.frontpage"
      @click="showHelper"
      @enter="searchRequest"
      :viewContent="search.viewFrontpageContent"
      :black="view.black" />  
      
    <Menu 
      @giveTime="changeTime"
      @changeProgram="selectedPrograms"
      @changeBroadcaster="selectedBroadcasters"
      @changeBroadcasterBool="showBroadcaster"
      v-if="view.menu"
      :begin="search.period.start"
      :end="search.period.end"
      :black="view.black" />

    <div id="results">
      <!-- <POMS :poms="results.poms"/> -->
      <Header 
        @enter="searchRequest"
        v-if="view.menu"
        @sorting="sort"
        @changeColor="changeColor"
        :term="search.term"
        :results="search.results"
        :placeholder="search.term"
        :black="view.black"
        :frontpage="view.frontpage" />

      <!-- Results -->  
      <div 
        id="results__collection" 
        v-infinite-scroll="loadMore" 
        infinite-scroll-disabled="busy" 
        infinite-scroll-distance="20">
        
        <p v-if="search.noResults">Geen resultaten</p>
        <Result 
          v-for="result in queryResults"
          :key="result._id"
          :result="result"
          :black="view.black" />
      </div>

      <!-- Histogram -->
      <Datavis 
        v-if="view.histogram"
        ref="datavis"
        v-on:change="anim($event)"
        @clicked="filterResults"
        :graphdata="results.timegram"
        :black="view.black" />
    </div>

    <Notification 
      v-if="!view.frontpage && view.ad"
      @hideAd="hideAd"
      :black="view.black" />

    <Loading
      v-if="view.loading"
      :resultsLeft="this.search.resultsLeft" />

    <Footer 
      v-if="!view.frontpage"
      v-on:showHisto="showHistogram"
      :black="view.black" />
  </div>
</template>

<script>
import Menu from './components/Menu'
import Header from './components/Header'
import Frontpage from './components/Frontpage'
import Result from './components/Result'
import Loading from './components/results/Loading'
import Notification from './components/Notification'
import Footer from './components/Footer'
import Datavis from './components/Datavis'
import Helper from './components/Helper'
import POMS from './components/POMS'

import programs from './components/data/programs.json'
import broadcasters from './components/data/broadcasters.json'

import infiniteScroll from 'vue-infinite-scroll'
import axios from 'axios'

// https://madewithlove.be/faceted-search-using-elasticsearch/

export default {
  name: 'App',
  components: {
    Menu, Header, Frontpage, Result, Loading, Notification, Footer, Datavis, POMS, Helper
  },
  directives: {infiniteScroll},
  data: function () {
    return {
      busy: true,
      view: {
        frontpage: true,
        black: true, // whether we use a black or light view
        menu: false,
        sort: 'time',
        textSize: 'small',
        loading: false,
        histogram: false,
        disableLoad: false,
        ad: true // small notification bar on the bottom of the page
      },
      search: {
        term: '',
        currentPage: 0,
        noResults: false,
        totalResults: 0,
        results: '',
        resultsLeft: 0,
        showHelper: false,
        showResults: false,
        viewFrontpageContent: true,
        sort: {
          order: 'asc'
        },
        filter: {
          broadcaster: true,
          selectedPrograms: programs.programs,
          selectedBroadcasters: broadcasters.broadcasters
        },
        period: {
          start: 1293840000,
          end: Date.now()/1000
        }
      },
      results: {
        timegram: '',
        poms: []
      },
      queryResults: []
    }
  },
  mounted: function () {
    /* Analytics stuff */
    window.dataLayer = window.dataLayer || []
    function gtag () { window.dataLayer.push(arguments) }
    gtag('js', new Date())

    gtag('config', 'UA-128077750-2')
  },
  methods: {
    hideAd () { this.view.ad = !this.view.ad },
    showHistogram () { this.view.histogram = !this.view.histogram },
    triggerNewCall () {
      this.clearResults()
      this.apiCall()     
    },
    clearResults () {
      this.queryResults = []
      this.search.currentPage = 0
    },
    noResults () {
      // console.log('geen resultaten')
      this.queryResults = []
      this.busy = true
      this.search.noResults = true
    },
    filterResults (time) {
      this.search.period.start = time / 1000
      this.triggerNewCall();
    },
    sort: function (sort) {
      this.search.sort.order = sort
      this.triggerNewCall();
    },
    changeTime (time) {
      this.search.period.start = time[0]
      this.search.period.end = time[1]
      this.triggerNewCall();
    },
    showBroadcaster (bool) {
      this.search.filter.broadcaster = bool;
      this.triggerNewCall();
    },
    selectedBroadcasters (broadcasterArray) {
      this.search.filter.selectedBroadcasters = broadcasterArray
      this.triggerNewCall();
    },
    selectedPrograms (programArray) {
      this.search.filter.selectedPrograms = programArray
      this.triggerNewCall();
    },
    searchRequest (value) {
      this.clearResults()
      this.search.term = value
      this.apiCall(true) // true if initial call
    },
    showHelper (bool) {
      this.search.showHelper = bool
      this.search.viewFrontpageContent = !bool
    },
    loadMore: function () {
      this.view.loading = true;

      console.log('left ', this.search.resultsLeft)

      if(this.search.resultsLeft < 0){
        this.view.loading = false;
        this.busy = false
        // console.log(this.busy)
      } else {
      this.busy = true

      setTimeout(() => {
        // console.log('loading')
        this.busy = false
        this.apiCall()
      }, 2000)
      }
    },
    changeColor: function (bool) {
      this.view.black = bool
    },
    apiCall: function (initial) {
      var filterTerm = {'broadcasters': this.search.filter.selectedBroadcasters}

      if (this.search.filter.broacaster === true) {
        filterTerm = {'broadcasters': this.search.filter.selectedBroadcasters}
      } else if (this.search.filter.broadcaster === false) {
        filterTerm = {'program': this.search.filter.selectedPrograms}
      }

      // To do
      // Add elastic module
      // console.log('gte ', this.search.period.start)
      var thisQuery = {
        'from': this.search.currentPage,
        'size': 10,
        'query': {
          'bool': {
            'must': [{
              'simple_query_string': {
                'fields': [
                  'line'
                ],
                'query': this.search.term
              }
            }, {
              'terms': filterTerm
            }
            ],
            'filter': {
              'range': {
                'date': {
                  'gte': this.search.period.start * 1000,
                  'lte': this.search.period.end * 1000
                }
              }
            }
          }
        },
        'aggs': {
          'programs_agg': {
            'terms': {
              'field': 'program'
            }
          },
          'timegram': {
            'date_histogram': {
              'field': 'date',
              'interval': 'month'
            }
          }
        },
        'highlight': {
          'pre_tags': ['<em class="highlight">'],
          'post_tags': ['</em>'],
          'fields': {
            'line': {}
          }
        },
        'sort': [
          { 'date': {
            'order': this.search.sort.order,
            'mode': 'avg'
          }
          }
        ]
      }

      this.search.currentPage += 10

      axios.get('https://zummie.com/api', {
        params: {
          source: JSON.stringify(thisQuery),
          source_content_type: 'application/json'
        }
      }).then((response) => {
        // console.log(response.data)
        if (initial === true) {
          this.view.frontpage = false
          this.view.menu = true
          this.search.showHelper = false

          window.dataLayer = window.dataLayer || []
          function gtag () { window.dataLayer.push(arguments) }

          gtag('config', 'UA-128077750-2')
          gtag('event', 'search', {
            'event_category' : 'query',
            'event_label' : this.search.term
          });
          if (response.data.hits.total === 0) {
            this.noResults()
            this.search.results = 'no results :\'('
          } else {
            this.search.results = response.data.hits.total + ' results'
            this.search.resultsLeft = response.data.hits.total - 10
            this.busy = false
            this.view.loading = false
            
          }
        } else {
          this.search.results = response.data.hits.total + ' results';
          this.search.resultsLeft -= 10;
          this.view.loading = false;
        }
        var _this = this
        this.results.timegram = response.data.aggregations.timegram
        for (var i = 0; i < response.data.hits.hits.length; i++) {
          _this.queryResults.push(response.data.hits.hits[i])
          _this.results.poms.push(response.data.hits.hits[i]._source.url)
        }

        // console.log(this.results.poms)
      })
    }
  }
}

</script>

<style global>
  html {
    font-size: 14px;
  }

  @font-face {
    font-family: 'fl-mono';
    src: url('./assets/fonts/37F288_0_0.woff') format('woff'); /* Pretty Modern Browsers */
  }

  @font-face {
    font-family: 'Feijoa-Medium';
    src: url('./assets/fonts/FeijoaWeb-Medium.woff') format('woff'); /* Pretty Modern Browsers */
  }

  @media only screen
  and (min-device-width : 375px)
  and (max-device-width : 667px)
  and (orientation : portrait) {
    .menu {
      width: 100% !important;
      position: initial !important;
    }

    #results {
      margin-left: 0 !important;
      overflow: unset !important;
      max-width: 100% !important;
      display: inline-block !important;
    }

    .header {
      display: none !important;
    }

    .footer__menu {
      margin-left: 0 !important;
    }
  }

  @media screen and (max-width: 1100px) {
      .header {
        padding: 56px 0 60px 60px !important;
      }

      .header__search {
        width: 175px !important;
      }

      .header__left {
        width:  300px !important;
      }

      .header__list {
        margin: 0 20px 0 0 !important;
      }
  }

  em {
    color: #FF6767;
    margin-left: 10px;
    margin-right: 10px;
    white-space: nowrap;
    font-style: normal;
  }

  body {
    background: #000;
    padding: 0;
    margin: 0;
  }

  ::-webkit-scrollbar {
    width: 0px;
    background: transparent;
  }

  .black_bg {
    background: #000000 !important;
  }

  .white_bg {
    background: rgba(239, 239, 239, 1) !important;
  }

  /* #app {
    min-height: 100vh;
  } */

  #results {
    margin-left: 20%;
    overflow: hidden;
    max-width: 80%;
    /* height: 300% !important; */
  }

  .result:last-child {
    margin-bottom: 20px;
  }

  #results__collection {
    /* height: 300vh; */
  }

  #frontpage {
    max-width: 100%;
    overflow: hidden;
  }

  .result:first-child {
    margin-top: 110px;
  }

  .tooltip {
    display: block !important;
    z-index: 10000;
  }
  .tooltip .tooltip-inner {
    font-family: 'fl-mono';
    font-size: 12px;
    background: #707070;
    color: rgb(239,239,239);
    padding: 5px 10px 4px;
  }
  .tooltip .tooltip-arrow {
    width: 0;
    height: 0;
    border-style: solid;
    position: absolute;
    margin: 5px;
    border-color: #707070;
  }
  .tooltip[x-placement^=top] {
    margin-bottom: 5px;
  }
  .tooltip[x-placement^=top] .tooltip-arrow {
    border-width: 5px 5px 0 5px;
    border-left-color: transparent !important;
    border-right-color: transparent !important;
    border-bottom-color: transparent !important;
    bottom: -5px;
    left: calc(50% - 5px);
    margin-top: 0;
    margin-bottom: 0;
  }
  .tooltip[x-placement^=bottom] {
    margin-top: 5px;
  }
  .tooltip[x-placement^=bottom] .tooltip-arrow {
    border-width: 0 5px 5px 5px;
    border-left-color: transparent !important;
    border-right-color: transparent !important;
    border-top-color: transparent !important;
    top: -5px;
    left: calc(50% - 5px);
    margin-top: 0;
    margin-bottom: 0;
  }
  .tooltip[x-placement^=right] {
    margin-left: 5px;
  }
  .tooltip[x-placement^=right] .tooltip-arrow {
    border-width: 5px 5px 5px 0;
    border-left-color: transparent !important;
    border-top-color: transparent !important;
    border-bottom-color: transparent !important;
    left: -5px;
    top: calc(50% - 5px);
    margin-left: 0;
    margin-right: 0;
  }
  .tooltip[x-placement^=left] {
    margin-right: 5px;
  }
  .tooltip[x-placement^=left] .tooltip-arrow {
    border-width: 5px 0 5px 5px;
    border-top-color: transparent !important;
    border-right-color: transparent !important;
    border-bottom-color: transparent !important;
    right: -5px;
    top: calc(50% - 5px);
    margin-left: 0;
    margin-right: 0;
  }
  .tooltip[aria-hidden=true] {
    visibility: hidden;
    opacity: 0;
    transition: opacity 0.15s, visibility 0.15s;
  }
  .tooltip[aria-hidden=false] {
    visibility: visible;
    opacity: 1;
    transition: opacity 0.15s;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue